import { connect } from 'react-redux';
import HistoryContainer from '@Pages/History/HistoryContainer';

function mapStateToProps() {
  return {};
}

const mapActionToProps = {};

export default connect(mapStateToProps, mapActionToProps)(HistoryContainer);
